module.exports = __webpack_public_path__ + "static/media/human-beh.a8381f99.png";